export const resetErrors = (dispatch, actions) => {
  dispatch(actions.setRegisterError(''));
  dispatch(actions.setRegisterErrors({}));
};